import { styled as i } from "@mui/joy";
const o = i("div")`
  display: flex;
  gap: 16px;

  & > * {
    flex: 1;
    min-width: 0;
  }
`;
export {
  o as Row
};
//# sourceMappingURL=Row.js.map
